<div class="overflow-y-auto h-full mt-24px pb-[100px] px-12px">
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" (click)="resetFilter()" class="flex text-link">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<div>
			<app-custom-datepicker
				class="w-[49%]"
				[defaultValue]="getController('fromDate')?.value"
				label="GENERAL_LABELS.START_DATE"
				(dateValue)="getController('fromDate')?.setValue($event)"
			></app-custom-datepicker>
			<app-custom-datepicker
				class="w-[49%]"
				[defaultValue]="getController('toDate')?.value"
				label="GENERAL_LABELS.END_DATE"
				(dateValue)="getController('toDate')?.setValue($event)"
			></app-custom-datepicker>
		</div>

		<mat-error>
			<div
				class="whitespace-nowrap"
				*ngIf="
					getController('toDate')?.value < getController('fromDate')?.value &&
					getController('toDate')?.value
				"
			>
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>

		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>

		<div class="mb-36px">
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'BOOKING.BOOKING_DETAILS.PAYMENT_STATUS' | translate }}
			</p>

			<div
				*ngFor="let paymentArrayy of spPayoutListenum; let i = index"
				class="flex justify-between border-[1px] border-[#D9DBE9] rounded-12px my-auto p-4 mb-2"
			>
				<div class="h-[24px]">
					<mat-checkbox
						(change)="paymentChanged($event, 'payoutstatus')"
						[value]="paymentArrayy?.value"
						class="ltr:mr-2 rtl:ml-2 mb-[19px]"
						[checked]="
							getController('payoutstatus')?.value?.includes(
								paymentArrayy?.value
							)
						"
					>
					</mat-checkbox>
					{{
						'PAYOUT.PAYOUT_LIST.' + paymentArrayy['name'].toUpperCase()
							| translate
					}}
				</div>
			</div>
		</div>
		<button
			[disabled]="
				filterCount == 0 ||
				(getController('toDate').value < getController('fromDate').value &&
					getController('toDate').value)
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-5"
			mat-button
			(click)="submit()"
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
